import { Component, Input, Output, EventEmitter } from '@angular/core';
import { GenerationStatusResponse, ProcessStatus } from '../../models/statement-generator.models';

/**
 * Progress Monitor Component
 * Displays real-time progress of statement generation
 */
@Component({
  selector: 'app-statement-progress-monitor',
  templateUrl: './statement-progress-monitor.component.html',
  styleUrls: ['./statement-progress-monitor.component.scss'],
  standalone: false
})
export class StatementProgressMonitorComponent {
  @Input() status!: GenerationStatusResponse;
  @Output() onClose = new EventEmitter<void>();
  @Output() onViewStatements = new EventEmitter<void>();
  @Output() onRetry = new EventEmitter<void>();

  getStatusIcon(status: ProcessStatus): string {
    switch (status) {
      case 'waiting': return 'schedule';
      case 'processing': return 'sync';
      case 'completed': return 'check_circle';
      case 'failed': return 'error';
      default: return 'help';
    }
  }

  getStatusLabel(status: ProcessStatus): string {
    switch (status) {
      case 'waiting': return 'Waiting to start...';
      case 'processing': return 'Generating statements...';
      case 'completed': return 'Generation completed!';
      case 'failed': return 'Generation failed';
      default: return 'Unknown status';
    }
  }

  getProgressColor(status: ProcessStatus): 'primary' | 'accent' | 'warn' {
    return status === 'failed' ? 'warn' : 'primary';
  }
}
